const data = [
  [1147651200000, 67],
  [1147737600000, 64],
  [1147824000000, 65],
  [1147910400000, 63],
  [1147996800000, 64],
  [1148256000000, 63],
  [1148342400000, 63],
  [1148428800000, 63],
  [1148515200000, 64],
  [1148601600000, 63],
  [1148947200000, 61],
  [1149033600000, 59],
  [1149120000000, 62],
  [1149206400000, 61],
  [1149465600000, 60],
  [1149552000000, 59],
  [1149638400000, 58],
  [1149724800000, 60],
  [1149811200000, 59],
  [1150070400000, 57],
  [1150156800000, 58],
  [1150243200000, 57],
  [1150329600000, 59],
  [1150416000000, 57],
  [1150675200000, 57],
  [1150761600000, 57],
  [1150848000000, 57],
  [1150934400000, 59],
  [1151020800000, 58],
  [1151280000000, 58],
  [1151366400000, 57],
  [1151452800000, 56],
  [1151539200000, 58],
  [1151625600000, 57],
  [1151884800000, 57],
  [1152057600000, 57],
  [1152144000000, 55],
  [1152230400000, 55],
  [1152489600000, 55],
  [1152576000000, 55],
  [1152662400000, 52],
  [1152748800000, 52],
  [1152835200000, 50],
  [1153094400000, 52],
  [1153180800000, 52],
  [1153267200000, 54],
  [1153353600000, 60],
  [1153440000000, 60],
  [1153699200000, 61],
  [1153785600000, 61],
  [1153872000000, 63],
  [1153958400000, 63],
  [1154044800000, 65],
  [1154304000000, 67],
  [1154390400000, 67],
  [1154476800000, 68],
  [1154563200000, 69],
  [1154649600000, 68],
  [1154908800000, 67],
  [1154995200000, 64],
  [1155081600000, 63],
  [1155168000000, 64],
  [1155254400000, 63],
  [1155513600000, 63],
  [1155600000000, 66],
  [1155686400000, 67],
  [1155772800000, 67],
  [1155859200000, 67],
  [1156118400000, 66],
  [1156204800000, 67],
  [1156291200000, 67],
  [1156377600000, 67],
  [1156464000000, 68],
  [1156723200000, 66],
  [1156809600000, 66],
  [1156896000000, 66],
  [1156982400000, 67],
  [1157068800000, 68],
  [1157414400000, 71],
  [1157500800000, 70],
  [1157587200000, 72],
  [1157673600000, 72],
  [1157932800000, 72],
  [1158019200000, 72],
  [1158105600000, 74],
  [1158192000000, 74],
  [1158278400000, 74],
  [1158537600000, 73],
  [1158624000000, 73],
  [1158710400000, 75],
  [1158796800000, 74],
  [1158883200000, 73],
  [1159142400000, 75],
  [1159228800000, 77],
  [1159315200000, 76],
  [1159401600000, 77],
  [1159488000000, 76],
  [1159747200000, 74],
  [1159833600000, 74],
  [1159920000000, 75],
  [1160006400000, 74],
  [1160092800000, 74],
  [1160352000000, 74],
  [1160438400000, 73],
  [1160524800000, 73],
  [1160611200000, 75],
  [1160697600000, 75],
  [1160956800000, 75],
  [1161043200000, 74],
  [1161129600000, 74],
  [1161216000000, 78],
  [1161302400000, 79],
  [1161561600000, 81],
  [1161648000000, 81],
  [1161734400000, 81],
  [1161820800000, 82],
  [1161907200000, 80],
  [1162166400000, 80],
  [1162252800000, 81],
  [1162339200000, 79],
  [1162425600000, 78],
  [1162512000000, 78],
  [1162771200000, 79],
  [1162857600000, 80],
  [1162944000000, 82],
  [1163030400000, 83],
  [1163116800000, 83],
  [1163376000000, 84],
  [1163462400000, 85],
  [1163548800000, 84],
  [1163635200000, 85],
  [1163721600000, 85],
  [1163980800000, 86],
  [1164067200000, 88],
  [1164153600000, 90],
  [1164326400000, 91],
  [1164585600000, 89],
  [1164672000000, 91],
  [1164758400000, 91],
  [1164844800000, 91],
  [1164931200000, 91],
  [1165190400000, 91],
  [1165276800000, 91],
  [1165363200000, 89],
  [1165449600000, 87],
  [1165536000000, 88],
  [1165795200000, 88],
  [1165881600000, 86],
  [1165968000000, 89],
  [1166054400000, 88],
  [1166140800000, 87],
  [1166400000000, 85],
  [1166486400000, 86],
  [1166572800000, 84],
  [1166659200000, 82],
  [1166745600000, 82],
  [1167091200000, 81],
  [1167177600000, 81],
  [1167264000000, 80],
  [1167350400000, 84],
  [1167782400000, 83],
  [1167868800000, 85],
  [1167955200000, 85],
  [1168214400000, 85],
  [1168300800000, 92],
  [1168387200000, 97],
  [1168473600000, 95],
  [1168560000000, 94],
  [1168905600000, 97],
  [1168992000000, 94],
  [1169078400000, 89],
  [1169164800000, 88],
  [1169424000000, 86],
  [1169510400000, 85],
  [1169596800000, 86],
  [1169683200000, 86],
  [1169769600000, 85],
  [1170028800000, 85],
  [1170115200000, 85],
  [1170201600000, 85],
  [1170288000000, 84],
  [1170374400000, 84],
  [1170633600000, 83],
  [1170720000000, 84],
  [1170806400000, 86],
  [1170892800000, 86],
  [1170979200000, 83],
  [1171238400000, 84],
  [1171324800000, 84],
  [1171411200000, 85],
  [1171497600000, 85],
  [1171584000000, 84],
  [1171929600000, 85],
  [1172016000000, 89],
  [1172102400000, 89],
  [1172188800000, 89],
  [1172448000000, 88],
  [1172534400000, 83],
  [1172620800000, 84],
  [1172707200000, 87],
  [1172793600000, 85],
  [1173052800000, 86],
  [1173139200000, 88],
  [1173225600000, 87],
  [1173312000000, 88],
  [1173398400000, 87],
  [1173657600000, 89],
  [1173744000000, 88],
  [1173830400000, 90],
  [1173916800000, 89],
  [1174003200000, 89],
  [1174262400000, 91],
  [1174348800000, 91],
  [1174435200000, 93],
  [1174521600000, 93],
  [1174608000000, 93],
  [1174867200000, 95],
  [1174953600000, 95],
  [1175040000000, 93],
  [1175126400000, 93],
  [1175212800000, 92],
  [1175472000000, 93],
  [1175558400000, 94],
  [1175644800000, 94],
  [1175731200000, 94],
  [1176076800000, 93],
  [1176163200000, 94],
  [1176249600000, 92],
  [1176336000000, 92],
  [1176422400000, 90],
  [1176681600000, 91],
  [1176768000000, 90],
  [1176854400000, 90],
  [1176940800000, 90],
  [1177027200000, 90],
  [1177286400000, 93],
  [1177372800000, 93],
  [1177459200000, 95],
  [1177545600000, 98],
  [1177632000000, 99],
  [1177891200000, 99],
  [1177977600000, 99],
  [1178064000000, 100],
  [1178150400000, 100],
  [1178236800000, 100],
  [1178496000000, 103],
  [1178582400000, 105],
  [1178668800000, 106],
  [1178755200000, 107],
  [1178841600000, 108],
  [1179100800000, 109],
  [1179187200000, 107],
  [1179273600000, 107],
  [1179360000000, 109],
  [1179446400000, 110],
  [1179705600000, 111],
  [1179792000000, 113],
  [1179878400000, 112],
  [1179964800000, 110],
  [1180051200000, 113],
  [1180396800000, 114],
  [1180483200000, 118],
  [1180569600000, 121],
  [1180656000000, 118],
  [1180915200000, 121],
  [1181001600000, 122],
  [1181088000000, 123],
  [1181174400000, 124],
  [1181260800000, 124],
  [1181520000000, 120],
  [1181606400000, 120],
  [1181692800000, 117],
  [1181779200000, 118],
  [1181865600000, 120],
  [1182124800000, 125],
  [1182211200000, 123],
  [1182297600000, 121],
  [1182384000000, 123],
  [1182470400000, 123],
  [1182729600000, 122],
  [1182816000000, 119],
  [1182902400000, 121],
  [1182988800000, 120],
  [1183075200000, 122],
  [1183334400000, 121],
  [1183420800000, 127],
  [1183593600000, 132],
  [1183680000000, 132],
  [1183939200000, 130],
  [1184025600000, 132],
  [1184112000000, 132],
  [1184198400000, 134],
  [1184284800000, 137],
  [1184544000000, 138],
  [1184630400000, 138],
  [1184716800000, 138],
  [1184803200000, 140],
  [1184889600000, 143],
  [1185148800000, 143],
  [1185235200000, 134],
  [1185321600000, 137],
  [1185408000000, 146],
  [1185494400000, 143],
  [1185753600000, 141],
  [1185840000000, 131],
  [1185926400000, 135],
  [1186012800000, 136],
  [1186099200000, 131],
  [1186358400000, 135],
  [1186444800000, 135],
  [1186531200000, 134],
  [1186617600000, 126],
  [1186704000000, 125],
  [1186963200000, 127],
  [1187049600000, 124],
  [1187136000000, 119],
  [1187222400000, 117],
  [1187308800000, 122],
  [1187568000000, 122],
  [1187654400000, 127],
  [1187740800000, 132],
  [1187827200000, 131],
  [1187913600000, 135],
  [1188172800000, 132],
  [1188259200000, 126],
  [1188345600000, 134],
  [1188432000000, 136],
  [1188518400000, 138],
  [1188864000000, 144],
  [1188950400000, 136],
  [1189036800000, 135],
  [1189123200000, 131],
  [1189382400000, 136],
  [1189468800000, 135],
  [1189555200000, 136],
  [1189641600000, 137],
  [1189728000000, 138],
  [1189987200000, 138],
  [1190073600000, 140],
  [1190160000000, 140],
  [1190246400000, 140],
  [1190332800000, 144],
  [1190592000000, 148],
  [1190678400000, 153],
  [1190764800000, 152],
  [1190851200000, 154],
  [1190937600000, 153],
  [1191196800000, 156],
  [1191283200000, 158],
  [1191369600000, 157],
  [1191456000000, 156],
  [1191542400000, 161],
  [1191801600000, 167],
  [1191888000000, 167],
  [1191974400000, 166],
  [1192060800000, 162],
  [1192147200000, 167],
  [1192406400000, 166],
  [1192492800000, 169],
  [1192579200000, 172],
  [1192665600000, 173],
  [1192752000000, 170],
  [1193011200000, 174],
  [1193097600000, 186],
  [1193184000000, 185],
  [1193270400000, 182],
  [1193356800000, 184],
  [1193616000000, 185],
  [1193702400000, 187],
  [1193788800000, 189],
  [1193875200000, 187],
  [1193961600000, 187],
  [1194220800000, 186],
  [1194307200000, 191],
  [1194393600000, 186],
  [1194480000000, 175],
  [1194566400000, 165],
  [1194825600000, 153],
  [1194912000000, 169],
  [1194998400000, 166],
  [1195084800000, 164],
  [1195171200000, 166],
  [1195430400000, 163],
  [1195516800000, 168],
  [1195603200000, 168],
  [1195776000000, 171],
  [1196035200000, 172],
  [1196121600000, 174],
  [1196208000000, 180],
  [1196294400000, 184],
  [1196380800000, 182],
  [1196640000000, 178],
  [1196726400000, 179],
  [1196812800000, 185],
  [1196899200000, 189],
  [1196985600000, 194],
  [1197244800000, 194],
  [1197331200000, 188],
  [1197417600000, 190],
  [1197504000000, 191],
  [1197590400000, 190],
  [1197849600000, 184],
  [1197936000000, 182],
  [1198022400000, 183],
  [1198108800000, 187],
  [1198195200000, 193],
  [1198454400000, 198],
  [1198627200000, 198],
  [1198713600000, 198],
  [1198800000000, 199],
  [1199059200000, 198],
  [1199232000000, 194],
  [1199318400000, 194],
  [1199404800000, 180],
  [1199664000000, 177],
  [1199750400000, 171],
  [1199836800000, 179],
  [1199923200000, 178],
  [1200009600000, 172],
  [1200268800000, 178],
  [1200355200000, 169],
  [1200441600000, 159],
  [1200528000000, 160],
  [1200614400000, 161],
  [1200960000000, 155],
  [1201046400000, 139],
  [1201132800000, 135],
  [1201219200000, 130],
  [1201478400000, 130],
  [1201564800000, 131],
  [1201651200000, 132],
  [1201737600000, 135],
  [1201824000000, 133],
  [1202083200000, 131],
  [1202169600000, 129],
  [1202256000000, 122],
  [1202342400000, 121],
  [1202428800000, 125],
  [1202688000000, 129],
  [1202774400000, 124],
  [1202860800000, 129],
  [1202947200000, 127],
  [1203033600000, 124],
  [1203379200000, 122],
  [1203465600000, 123],
  [1203552000000, 121],
  [1203638400000, 119],
  [1203897600000, 119],
  [1203984000000, 119],
  [1204070400000, 122],
  [1204156800000, 129],
  [1204243200000, 125],
  [1204502400000, 121],
  [1204588800000, 124],
  [1204675200000, 124],
  [1204761600000, 120],
  [1204848000000, 122],
  [1205107200000, 119],
  [1205193600000, 127],
  [1205280000000, 126],
  [1205366400000, 127],
  [1205452800000, 126],
  [1205712000000, 126],
  [1205798400000, 132],
  [1205884800000, 129],
  [1205971200000, 133],
  [1206316800000, 139],
  [1206403200000, 140],
  [1206489600000, 145],
  [1206576000000, 140],
  [1206662400000, 143],
  [1206921600000, 143],
  [1207008000000, 149],
  [1207094400000, 147],
  [1207180800000, 151],
  [1207267200000, 153],
  [1207526400000, 155],
  [1207612800000, 152],
  [1207699200000, 151],
  [1207785600000, 154],
  [1207872000000, 147],
  [1208131200000, 147],
  [1208217600000, 148],
  [1208304000000, 153],
  [1208390400000, 154],
  [1208476800000, 161],
  [1208736000000, 168],
  [1208822400000, 160],
  [1208908800000, 162],
  [1208995200000, 168],
  [1209081600000, 169],
  [1209340800000, 172],
  [1209427200000, 175],
  [1209513600000, 173],
  [1209600000000, 180],
  [1209686400000, 180],
  [1209945600000, 184],
  [1210032000000, 186],
  [1210118400000, 182],
  [1210204800000, 185],
  [1210291200000, 183],
  [1210550400000, 188],
  [1210636800000, 189],
  [1210723200000, 186],
  [1210809600000, 189],
  [1210896000000, 187],
  [1211155200000, 183],
  [1211241600000, 185],
  [1211328000000, 178],
  [1211414400000, 177],
  [1211500800000, 181],
  [1211846400000, 186],
  [1211932800000, 187],
  [1212019200000, 186],
  [1212105600000, 188],
  [1212364800000, 186],
  [1212451200000, 185],
  [1212537600000, 185],
  [1212624000000, 189],
  [1212710400000, 185],
  [1212969600000, 181],
  [1213056000000, 185],
  [1213142400000, 180],
  [1213228800000, 173],
  [1213315200000, 172],
  [1213574400000, 176],
  [1213660800000, 181],
  [1213747200000, 178],
  [1213833600000, 180],
  [1213920000000, 175],
  [1214179200000, 173],
  [1214265600000, 173],
  [1214352000000, 177],
  [1214438400000, 168],
  [1214524800000, 170],
  [1214784000000, 167],
  [1214870400000, 174],
  [1214956800000, 168],
  [1215043200000, 170],
  [1215388800000, 175],
  [1215475200000, 179],
  [1215561600000, 174],
  [1215648000000, 176],
  [1215734400000, 172],
  [1215993600000, 173],
  [1216080000000, 169],
  [1216166400000, 172],
  [1216252800000, 171],
  [1216339200000, 165],
  [1216598400000, 166],
  [1216684800000, 162],
  [1216771200000, 166],
  [1216857600000, 159],
  [1216944000000, 162],
  [1217203200000, 154],
  [1217289600000, 157],
  [1217376000000, 159],
  [1217462400000, 158],
  [1217548800000, 156],
  [1217808000000, 153],
  [1217894400000, 160],
  [1217980800000, 164],
  [1218067200000, 163],
  [1218153600000, 169],
  [1218412800000, 173],
  [1218499200000, 176],
  [1218585600000, 179],
  [1218672000000, 179],
  [1218758400000, 175],
  [1219017600000, 175],
  [1219104000000, 173],
  [1219190400000, 175],
  [1219276800000, 174],
  [1219363200000, 176],
  [1219622400000, 172],
  [1219708800000, 173],
  [1219795200000, 174],
  [1219881600000, 173],
  [1219968000000, 169],
  [1220313600000, 166],
  [1220400000000, 166],
  [1220486400000, 161],
  [1220572800000, 160],
  [1220832000000, 157],
  [1220918400000, 151],
  [1221004800000, 151],
  [1221091200000, 152],
  [1221177600000, 148],
  [1221436800000, 140],
  [1221523200000, 139],
  [1221609600000, 127],
  [1221696000000, 134],
  [1221782400000, 140],
  [1222041600000, 131],
  [1222128000000, 126],
  [1222214400000, 128],
  [1222300800000, 131],
  [1222387200000, 128],
  [1222646400000, 105],
  [1222732800000, 113],
  [1222819200000, 109],
  [1222905600000, 100],
  [1222992000000, 97],
  [1223251200000, 98],
  [1223337600000, 89],
  [1223424000000, 89],
  [1223510400000, 88],
  [1223596800000, 96],
  [1223856000000, 110],
  [1223942400000, 104],
  [1224028800000, 97],
  [1224115200000, 101],
  [1224201600000, 97],
  [1224460800000, 98],
  [1224547200000, 91],
  [1224633600000, 96],
  [1224720000000, 98],
  [1224806400000, 96],
  [1225065600000, 92],
  [1225152000000, 99],
  [1225238400000, 104],
  [1225324800000, 111],
  [1225411200000, 107],
  [1225670400000, 106],
  [1225756800000, 110],
  [1225843200000, 103],
  [1225929600000, 99],
  [1226016000000, 98],
  [1226275200000, 95],
  [1226361600000, 94],
  [1226448000000, 90],
  [1226534400000, 96],
  [1226620800000, 90],
  [1226880000000, 88],
  [1226966400000, 89],
  [1227052800000, 86],
  [1227139200000, 80],
  [1227225600000, 82],
  [1227484800000, 92],
  [1227571200000, 90],
  [1227657600000, 95],
  [1227744000000, 95],
  [1227830400000, 92],
  [1228089600000, 88],
  [1228176000000, 92],
  [1228262400000, 95],
  [1228348800000, 91],
  [1228435200000, 94],
  [1228694400000, 99],
  [1228780800000, 100],
  [1228867200000, 98],
  [1228953600000, 95],
  [1229040000000, 98],
  [1229299200000, 94],
  [1229385600000, 95],
  [1229472000000, 89],
  [1229558400000, 89],
  [1229644800000, 90],
  [1229904000000, 85],
  [1229990400000, 86],
  [1230076800000, 85],
  [1230163200000, 85],
  [1230249600000, 85],
  [1230508800000, 86],
  [1230595200000, 86],
  [1230681600000, 85],
  [1230768000000, 85],
  [1230854400000, 90],
  [1231113600000, 94],
  [1231200000000, 93],
  [1231286400000, 91],
  [1231372800000, 92],
  [1231459200000, 90],
  [1231718400000, 88],
  [1231804800000, 87],
  [1231891200000, 85],
  [1231977600000, 83],
  [1232064000000, 82],
  [1232409600000, 78],
  [1232496000000, 82],
  [1232582400000, 88],
  [1232668800000, 88],
  [1232928000000, 89],
  [1233014400000, 90],
  [1233100800000, 94],
  [1233187200000, 93],
  [1233273600000, 90],
  [1233532800000, 91],
  [1233619200000, 92],
  [1233705600000, 93],
  [1233792000000, 96],
  [1233878400000, 99],
  [1234137600000, 102],
  [1234224000000, 97],
  [1234310400000, 96],
  [1234396800000, 99],
  [1234483200000, 99],
  [1234828800000, 94],
  [1234915200000, 94],
  [1235001600000, 90],
  [1235088000000, 91],
  [1235347200000, 86],
  [1235433600000, 90],
  [1235520000000, 91],
  [1235606400000, 89],
  [1235692800000, 89],
  [1235952000000, 87],
  [1236038400000, 88],
  [1236124800000, 91],
  [1236211200000, 88],
  [1236297600000, 85],
  [1236556800000, 83],
  [1236643200000, 88],
  [1236729600000, 92],
  [1236816000000, 96],
  [1236902400000, 95],
  [1237161600000, 95],
  [1237248000000, 99],
  [1237334400000, 101],
  [1237420800000, 101],
  [1237507200000, 101],
  [1237766400000, 107],
  [1237852800000, 106],
  [1237939200000, 106],
  [1238025600000, 109],
  [1238112000000, 106],
  [1238371200000, 104],
  [1238457600000, 105],
  [1238544000000, 108],
  [1238630400000, 112],
  [1238716800000, 115],
  [1238976000000, 118],
  [1239062400000, 115],
  [1239148800000, 116],
  [1239235200000, 119],
  [1239321600000, 119],
  [1239580800000, 120],
  [1239667200000, 118],
  [1239753600000, 117],
  [1239840000000, 121],
  [1239926400000, 123],
  [1240185600000, 120],
  [1240272000000, 121],
  [1240358400000, 121],
  [1240444800000, 125],
  [1240531200000, 123],
  [1240790400000, 124],
  [1240876800000, 123],
  [1240963200000, 125],
  [1241049600000, 125],
  [1241136000000, 127],
  [1241395200000, 132],
  [1241481600000, 132],
  [1241568000000, 132],
  [1241654400000, 129],
  [1241740800000, 129],
  [1242000000000, 129],
  [1242086400000, 124],
  [1242172800000, 119],
  [1242259200000, 122],
  [1242345600000, 122],
  [1242604800000, 126],
  [1242691200000, 127],
  [1242777600000, 125],
  [1242864000000, 124],
  [1242950400000, 122],
  [1243296000000, 130],
  [1243382400000, 133],
  [1243468800000, 135],
  [1243555200000, 135],
  [1243814400000, 139],
  [1243900800000, 139],
  [1243987200000, 140],
  [1244073600000, 143],
  [1244160000000, 144],
  [1244419200000, 143],
  [1244505600000, 142],
  [1244592000000, 140],
  [1244678400000, 139],
  [1244764800000, 136],
  [1245024000000, 136],
  [1245110400000, 136],
  [1245196800000, 135],
  [1245283200000, 135],
  [1245369600000, 139],
  [1245628800000, 137],
  [1245715200000, 134],
  [1245801600000, 136],
  [1245888000000, 139],
  [1245974400000, 142],
  [1246233600000, 141],
  [1246320000000, 142],
  [1246406400000, 142],
  [1246492800000, 140],
  [1246579200000, 140],
  [1246838400000, 138],
  [1246924800000, 135],
  [1247011200000, 137],
  [1247097600000, 136],
  [1247184000000, 138],
  [1247443200000, 142],
  [1247529600000, 142],
  [1247616000000, 146],
  [1247702400000, 147],
  [1247788800000, 151],
  [1248048000000, 152],
  [1248134400000, 151],
  [1248220800000, 156],
  [1248307200000, 157],
  [1248393600000, 159],
  [1248652800000, 160],
  [1248739200000, 160],
  [1248825600000, 160],
  [1248912000000, 162],
  [1248998400000, 163],
  [1249257600000, 166],
  [1249344000000, 165],
  [1249430400000, 165],
  [1249516800000, 163],
  [1249603200000, 165],
  [1249862400000, 164],
  [1249948800000, 162],
  [1250035200000, 165],
  [1250121600000, 168],
  [1250208000000, 166],
  [1250467200000, 159],
  [1250553600000, 164],
  [1250640000000, 164],
  [1250726400000, 166],
  [1250812800000, 169],
  [1251072000000, 169],
  [1251158400000, 169],
  [1251244800000, 167],
  [1251331200000, 169],
  [1251417600000, 170],
  [1251676800000, 168],
  [1251763200000, 165],
  [1251849600000, 165],
  [1251936000000, 166],
  [1252022400000, 170],
  [1252368000000, 172],
  [1252454400000, 171],
  [1252540800000, 172],
  [1252627200000, 172],
  [1252886400000, 173],
  [1252972800000, 175],
  [1253059200000, 181],
  [1253145600000, 184],
  [1253232000000, 185],
  [1253491200000, 184],
  [1253577600000, 184],
  [1253664000000, 185],
  [1253750400000, 183],
  [1253836800000, 182],
  [1254096000000, 186],
  [1254182400000, 185],
  [1254268800000, 185],
  [1254355200000, 180],
  [1254441600000, 184],
  [1254700800000, 186],
  [1254787200000, 190],
  [1254873600000, 190],
  [1254960000000, 189],
  [1255046400000, 190],
  [1255305600000, 190],
  [1255392000000, 190],
  [1255478400000, 191],
  [1255564800000, 190],
  [1255651200000, 188],
  [1255910400000, 189],
  [1255996800000, 198],
  [1256083200000, 204],
  [1256169600000, 205],
  [1256256000000, 203],
  [1256515200000, 202],
  [1256601600000, 197],
  [1256688000000, 192],
  [1256774400000, 196],
  [1256860800000, 188],
  [1257120000000, 189],
  [1257206400000, 188],
  [1257292800000, 190],
  [1257379200000, 194],
  [1257465600000, 194],
  [1257724800000, 201],
  [1257811200000, 202],
  [1257897600000, 203],
  [1257984000000, 201],
  [1258070400000, 204],
  [1258329600000, 206],
  [1258416000000, 207],
  [1258502400000, 205],
  [1258588800000, 200],
  [1258675200000, 199],
  [1258934400000, 205],
  [1259020800000, 204],
  [1259107200000, 204],
  [1259193600000, 204],
  [1259280000000, 200],
  [1259539200000, 199],
  [1259625600000, 196],
  [1259712000000, 196],
  [1259798400000, 196],
  [1259884800000, 193],
  [1260144000000, 188],
  [1260230400000, 189],
  [1260316800000, 197],
  [1260403200000, 196],
  [1260489600000, 194],
  [1260748800000, 196],
  [1260835200000, 194],
  [1260921600000, 195],
  [1261008000000, 191],
  [1261094400000, 195],
  [1261353600000, 198],
  [1261440000000, 200],
  [1261526400000, 202],
  [1261612800000, 209],
  [1261699200000, 209],
  [1261958400000, 211],
  [1262044800000, 209],
  [1262131200000, 211],
  [1262217600000, 210],
  [1262304000000, 210],
  [1262563200000, 214],
  [1262649600000, 214],
  [1262736000000, 210],
  [1262822400000, 210],
  [1262908800000, 211],
  [1263168000000, 210],
  [1263254400000, 207],
  [1263340800000, 210],
  [1263427200000, 209],
  [1263513600000, 205],
  [1263772800000, 205],
  [1263859200000, 215],
  [1263945600000, 211],
  [1264032000000, 208],
  [1264118400000, 197],
  [1264377600000, 203],
  [1264464000000, 205],
  [1264550400000, 207],
  [1264636800000, 199],
  [1264723200000, 192],
  [1264982400000, 194],
  [1265068800000, 195],
  [1265155200000, 199],
  [1265241600000, 192],
  [1265328000000, 195],
  [1265587200000, 194],
  [1265673600000, 196],
  [1265760000000, 195],
  [1265846400000, 198],
  [1265932800000, 200],
  [1266192000000, 200],
  [1266278400000, 203],
  [1266364800000, 202],
  [1266451200000, 202],
  [1266537600000, 201],
  [1266796800000, 200],
  [1266883200000, 197],
  [1266969600000, 200],
  [1267056000000, 202],
  [1267142400000, 204],
  [1267401600000, 208],
  [1267488000000, 208],
  [1267574400000, 209],
  [1267660800000, 210],
  [1267747200000, 218],
  [1268006400000, 219],
  [1268092800000, 223],
  [1268179200000, 224],
  [1268265600000, 225],
  [1268352000000, 226],
  [1268611200000, 223],
  [1268697600000, 224],
  [1268784000000, 224],
  [1268870400000, 224],
  [1268956800000, 222],
  [1269216000000, 224],
  [1269302400000, 228],
  [1269388800000, 229],
  [1269475200000, 226],
  [1269561600000, 230],
  [1269820800000, 232],
  [1269907200000, 235],
  [1269993600000, 235],
  [1270080000000, 235],
  [1270166400000, 235],
  [1270425600000, 238],
  [1270512000000, 239],
  [1270598400000, 240],
  [1270684800000, 239],
  [1270771200000, 241],
  [1271030400000, 242],
  [1271116800000, 242],
  [1271203200000, 245],
  [1271289600000, 248],
  [1271376000000, 247],
  [1271635200000, 247],
  [1271721600000, 244],
  [1271808000000, 259],
  [1271894400000, 266],
  [1271980800000, 270],
  [1272240000000, 269],
  [1272326400000, 262],
  [1272412800000, 261],
  [1272499200000, 268],
  [1272585600000, 261],
  [1272844800000, 266],
  [1272931200000, 258],
  [1273017600000, 255],
  [1273104000000, 246],
  [1273190400000, 235],
  [1273449600000, 253],
  [1273536000000, 256],
  [1273622400000, 262],
  [1273708800000, 258],
  [1273795200000, 253],
  [1274054400000, 254],
  [1274140800000, 252],
  [1274227200000, 248],
  [1274313600000, 237],
  [1274400000000, 242],
  [1274659200000, 246],
  [1274745600000, 245],
  [1274832000000, 244],
  [1274918400000, 253],
  [1275004800000, 256],
  [1275264000000, 256],
  [1275350400000, 260],
  [1275436800000, 263],
  [1275523200000, 263],
  [1275609600000, 255],
  [1275868800000, 250],
  [1275955200000, 249],
  [1276041600000, 243],
  [1276128000000, 250],
  [1276214400000, 253],
  [1276473600000, 254],
  [1276560000000, 259],
  [1276646400000, 267],
  [1276732800000, 271],
  [1276819200000, 274],
  [1277078400000, 270],
  [1277164800000, 273],
  [1277251200000, 270],
  [1277337600000, 269],
  [1277424000000, 266],
  [1277683200000, 268],
  [1277769600000, 256],
  [1277856000000, 251],
  [1277942400000, 248],
  [1278028800000, 246],
  [1278288000000, 246],
  [1278374400000, 248],
  [1278460800000, 258],
  [1278547200000, 258],
  [1278633600000, 259],
  [1278892800000, 257],
  [1278979200000, 251],
  [1279065600000, 252],
  [1279152000000, 251],
  [1279238400000, 249],
  [1279497600000, 245],
  [1279584000000, 251],
  [1279670400000, 254],
  [1279756800000, 259],
  [1279843200000, 259],
  [1280102400000, 259],
  [1280188800000, 264],
  [1280275200000, 260],
  [1280361600000, 258],
  [1280448000000, 257],
  [1280707200000, 261],
  [1280793600000, 261],
  [1280880000000, 262],
  [1280966400000, 261],
  [1281052800000, 260],
  [1281312000000, 261],
  [1281398400000, 259],
  [1281484800000, 250],
  [1281571200000, 251],
  [1281657600000, 249],
  [1281916800000, 247],
  [1282003200000, 251],
  [1282089600000, 253],
  [1282176000000, 249],
  [1282262400000, 249],
  [1282521600000, 245],
  [1282608000000, 239],
  [1282694400000, 242],
  [1282780800000, 240],
  [1282867200000, 241],
  [1283126400000, 242],
  [1283212800000, 243],
  [1283299200000, 250],
  [1283385600000, 252],
  [1283472000000, 258],
  [1283731200000, 258],
  [1283817600000, 257],
  [1283904000000, 262],
  [1283990400000, 263],
  [1284076800000, 263],
  [1284336000000, 267],
  [1284422400000, 268],
  [1284508800000, 270],
  [1284595200000, 276],
  [1284681600000, 275],
  [1284940800000, 283],
  [1285027200000, 283],
  [1285113600000, 287],
  [1285200000000, 288],
  [1285286400000, 292],
  [1285545600000, 291],
  [1285632000000, 286],
  [1285718400000, 287],
  [1285804800000, 283],
  [1285891200000, 282],
  [1286150400000, 278],
  [1286236800000, 288],
  [1286323200000, 289],
  [1286409600000, 289],
  [1286496000000, 294],
  [1286755200000, 295],
  [1286841600000, 298],
  [1286928000000, 300],
  [1287014400000, 302],
  [1287100800000, 314],
  [1287360000000, 318],
  [1287446400000, 309],
  [1287532800000, 310],
  [1287619200000, 309],
  [1287705600000, 307],
  [1287964800000, 308],
  [1288051200000, 308],
  [1288137600000, 307],
  [1288224000000, 305],
  [1288310400000, 300],
  [1288569600000, 304],
  [1288656000000, 309],
  [1288742400000, 312],
  [1288828800000, 318],
  [1288915200000, 317],
  [1289174400000, 318],
  [1289260800000, 316],
  [1289347200000, 318],
  [1289433600000, 316],
  [1289520000000, 308],
  [1289779200000, 307],
  [1289865600000, 301],
  [1289952000000, 300],
  [1290038400000, 308],
  [1290124800000, 306],
  [1290384000000, 313],
  [1290470400000, 308],
  [1290556800000, 314],
  [1290729600000, 315],
  [1290988800000, 316],
  [1291075200000, 311],
  [1291161600000, 316],
  [1291248000000, 318],
  [1291334400000, 317],
  [1291593600000, 320],
  [1291680000000, 318],
  [1291766400000, 321],
  [1291852800000, 319],
  [1291939200000, 320],
  [1292198400000, 321],
  [1292284800000, 320],
  [1292371200000, 320],
  [1292457600000, 321],
  [1292544000000, 320],
  [1292803200000, 322],
  [1292889600000, 324],
  [1292976000000, 325],
  [1293062400000, 323],
  [1293408000000, 324],
  [1293494400000, 325],
  [1293580800000, 325],
  [1293667200000, 323],
  [1293753600000, 322],
  [1294012800000, 329],
  [1294099200000, 331],
  [1294185600000, 334],
  [1294272000000, 333],
  [1294358400000, 336],
  [1294617600000, 342],
  [1294704000000, 341],
  [1294790400000, 344],
  [1294876800000, 345],
  [1294963200000, 348],
  [1295308800000, 340],
  [1295395200000, 338],
  [1295481600000, 332],
  [1295568000000, 326],
  [1295827200000, 337],
  [1295913600000, 341],
  [1296000000000, 343],
  [1296086400000, 343],
  [1296172800000, 336],
  [1296432000000, 339],
  [1296518400000, 345],
  [1296604800000, 344],
  [1296691200000, 343],
  [1296777600000, 346],
  [1297036800000, 351],
  [1297123200000, 355],
  [1297209600000, 358],
  [1297296000000, 354],
  [1297382400000, 356],
  [1297641600000, 359],
  [1297728000000, 359],
  [1297814400000, 363],
  [1297900800000, 358],
  [1297987200000, 350],
  [1298332800000, 338],
  [1298419200000, 342],
  [1298505600000, 342],
  [1298592000000, 348],
  [1298851200000, 353],
  [1298937600000, 349],
  [1299024000000, 352],
  [1299110400000, 359],
  [1299196800000, 360],
  [1299456000000, 355],
  [1299542400000, 355],
  [1299628800000, 352],
  [1299715200000, 346],
  [1299801600000, 351],
  [1300060800000, 353],
  [1300147200000, 345],
  [1300233600000, 330],
  [1300320000000, 334],
  [1300406400000, 330],
  [1300665600000, 339],
  [1300752000000, 341],
  [1300838400000, 339],
  [1300924800000, 344],
  [1301011200000, 351],
  [1301270400000, 350],
  [1301356800000, 350],
  [1301443200000, 348],
  [1301529600000, 348],
  [1301616000000, 344],
  [1301875200000, 341],
  [1301961600000, 338],
  [1302048000000, 338],
  [1302134400000, 338],
  [1302220800000, 335],
  [1302480000000, 330],
  [1302566400000, 332],
  [1302652800000, 336],
  [1302739200000, 332],
  [1302825600000, 327],
  [1303084800000, 331],
  [1303171200000, 337],
  [1303257600000, 342],
  [1303344000000, 350],
  [1303689600000, 353],
  [1303776000000, 350],
  [1303862400000, 350],
  [1303948800000, 346],
  [1304035200000, 350],
  [1304294400000, 346],
  [1304380800000, 348],
  [1304467200000, 349],
  [1304553600000, 346],
  [1304640000000, 346],
  [1304899200000, 347],
  [1304985600000, 349],
  [1305072000000, 347],
  [1305158400000, 346],
  [1305244800000, 340],
  [1305504000000, 333],
  [1305590400000, 336],
  [1305676800000, 339],
  [1305763200000, 340],
  [1305849600000, 335],
  [1306108800000, 334],
  [1306195200000, 332],
  [1306281600000, 336],
  [1306368000000, 335],
  [1306454400000, 337],
  [1306800000000, 347],
  [1306886400000, 345],
  [1306972800000, 346],
  [1307059200000, 343],
  [1307318400000, 338],
  [1307404800000, 332],
  [1307491200000, 332],
  [1307577600000, 331],
  [1307664000000, 325],
  [1307923200000, 326],
  [1308009600000, 332],
  [1308096000000, 326],
  [1308182400000, 325],
  [1308268800000, 320],
  [1308528000000, 315],
  [1308614400000, 325],
  [1308700800000, 322],
  [1308787200000, 331],
  [1308873600000, 326],
  [1309132800000, 332],
  [1309219200000, 335],
  [1309305600000, 334],
  [1309392000000, 335],
  [1309478400000, 343],
  [1309824000000, 349],
  [1309910400000, 351],
  [1309996800000, 357],
  [1310083200000, 359],
  [1310342400000, 354],
  [1310428800000, 353],
  [1310515200000, 358],
  [1310601600000, 357],
  [1310688000000, 364],
  [1310947200000, 373],
  [1311033600000, 376],
  [1311120000000, 386],
  [1311206400000, 387],
  [1311292800000, 393],
  [1311552000000, 398],
  [1311638400000, 403],
  [1311724800000, 392],
  [1311811200000, 391],
  [1311897600000, 390],
  [1312156800000, 396],
  [1312243200000, 388],
  [1312329600000, 392],
  [1312416000000, 377],
  [1312502400000, 373],
  [1312761600000, 353],
  [1312848000000, 374],
  [1312934400000, 363],
  [1313020800000, 373],
  [1313107200000, 376],
  [1313366400000, 383],
  [1313452800000, 380],
  [1313539200000, 380],
  [1313625600000, 366],
  [1313712000000, 356],
  [1313971200000, 356],
  [1314057600000, 373],
  [1314144000000, 376],
  [1314230400000, 373],
  [1314316800000, 383],
  [1314576000000, 389],
  [1314662400000, 389],
  [1314748800000, 384],
  [1314835200000, 381],
  [1314921600000, 374],
  [1315267200000, 379],
  [1315353600000, 383],
  [1315440000000, 384],
  [1315526400000, 377],
  [1315785600000, 379],
  [1315872000000, 384],
  [1315958400000, 389],
  [1316044800000, 392],
  [1316131200000, 400],
  [1316390400000, 411],
  [1316476800000, 413],
  [1316563200000, 412],
  [1316649600000, 401],
  [1316736000000, 404],
  [1316995200000, 403],
  [1317081600000, 399],
  [1317168000000, 397],
  [1317254400000, 390],
  [1317340800000, 381],
  [1317600000000, 374],
  [1317686400000, 372],
  [1317772800000, 378],
  [1317859200000, 377],
  [1317945600000, 369],
  [1318204800000, 388],
  [1318291200000, 400],
  [1318377600000, 402],
  [1318464000000, 408],
  [1318550400000, 422],
  [1318809600000, 419],
  [1318896000000, 422],
  [1318982400000, 398],
  [1319068800000, 395],
  [1319155200000, 392],
  [1319414400000, 405],
  [1319500800000, 397],
  [1319587200000, 400],
  [1319673600000, 404],
  [1319760000000, 404],
  [1320019200000, 404],
  [1320105600000, 396],
  [1320192000000, 397],
  [1320278400000, 403],
  [1320364800000, 400],
  [1320624000000, 399],
  [1320710400000, 406],
  [1320796800000, 395],
  [1320883200000, 385],
  [1320969600000, 384],
  [1321228800000, 379],
  [1321315200000, 388],
  [1321401600000, 384],
  [1321488000000, 377],
  [1321574400000, 374],
  [1321833600000, 369],
  [1321920000000, 376],
  [1322006400000, 366],
  [1322179200000, 363],
  [1322438400000, 376],
  [1322524800000, 373],
  [1322611200000, 382],
  [1322697600000, 387],
  [1322784000000, 389],
  [1323043200000, 393],
  [1323129600000, 390],
  [1323216000000, 389],
  [1323302400000, 390],
  [1323388800000, 393],
  [1323648000000, 391],
  [1323734400000, 388],
  [1323820800000, 380],
  [1323907200000, 378],
  [1323993600000, 381],
  [1324252800000, 382],
  [1324339200000, 395],
  [1324425600000, 396],
  [1324512000000, 398],
  [1324598400000, 403],
  [1324944000000, 406],
  [1325030400000, 402],
  [1325116800000, 405],
  [1325203200000, 405],
  [1325548800000, 411],
  [1325635200000, 413],
  [1325721600000, 418],
  [1325808000000, 422],
  [1326067200000, 421],
  [1326153600000, 423],
  [1326240000000, 422],
  [1326326400000, 421],
  [1326412800000, 419],
  [1326758400000, 424],
  [1326844800000, 429],
  [1326931200000, 427],
  [1327017600000, 420],
  [1327276800000, 427],
  [1327363200000, 420],
  [1327449600000, 446],
  [1327536000000, 444],
  [1327622400000, 447],
  [1327881600000, 453],
  [1327968000000, 456],
  [1328054400000, 456],
  [1328140800000, 455],
  [1328227200000, 459],
  [1328486400000, 463],
  [1328572800000, 468],
  [1328659200000, 476],
  [1328745600000, 493],
  [1328832000000, 493],
  [1329091200000, 502],
  [1329177600000, 509],
  [1329264000000, 497],
  [1329350400000, 502],
  [1329436800000, 502],
  [1329782400000, 514],
  [1329868800000, 513],
  [1329955200000, 516],
  [1330041600000, 522],
  [1330300800000, 525],
  [1330387200000, 535],
  [1330473600000, 542],
  [1330560000000, 544],
  [1330646400000, 545],
  [1330905600000, 533],
  [1330992000000, 530],
  [1331078400000, 530],
  [1331164800000, 541],
  [1331251200000, 545],
  [1331510400000, 552],
  [1331596800000, 568],
  [1331683200000, 589],
  [1331769600000, 585],
  [1331856000000, 585],
  [1332115200000, 601],
  [1332201600000, 605],
  [1332288000000, 602],
  [1332374400000, 599],
  [1332460800000, 596],
  [1332720000000, 606],
  [1332806400000, 614],
  [1332892800000, 617],
  [1332979200000, 609],
  [1333065600000, 599],
  [1333324800000, 618],
  [1333411200000, 629],
  [1333497600000, 624],
  [1333584000000, 633],
  [1333929600000, 636],
  [1334016000000, 628],
  [1334102400000, 626],
  [1334188800000, 622],
  [1334275200000, 605],
  [1334534400000, 580],
  [1334620800000, 609],
  [1334707200000, 608],
  [1334793600000, 587],
  [1334880000000, 572],
  [1335139200000, 571],
  [1335225600000, 560],
  [1335312000000, 610],
  [1335398400000, 607],
  [1335484800000, 603],
  [1335744000000, 583],
  [1335830400000, 582],
  [1335916800000, 585],
  [1336003200000, 581],
  [1336089600000, 565],
  [1336348800000, 569],
  [1336435200000, 568],
  [1336521600000, 569],
  [1336608000000, 570],
  [1336694400000, 566],
  [1336953600000, 558],
  [1337040000000, 553],
  [1337126400000, 546],
  [1337212800000, 530],
  [1337299200000, 530],
  [1337558400000, 561],
  [1337644800000, 556],
  [1337731200000, 570],
  [1337817600000, 565],
  [1337904000000, 562],
  [1338249600000, 572],
  [1338336000000, 579],
  [1338422400000, 577],
  [1338508800000, 560],
  [1338768000000, 564],
  [1338854400000, 562],
  [1338940800000, 571],
  [1339027200000, 571],
  [1339113600000, 580],
  [1339372800000, 571],
  [1339459200000, 576],
  [1339545600000, 572],
  [1339632000000, 571],
  [1339718400000, 574],
  [1339977600000, 585],
  [1340064000000, 587],
  [1340150400000, 585],
  [1340236800000, 577],
  [1340323200000, 582],
  [1340582400000, 570],
  [1340668800000, 572],
  [1340755200000, 574],
  [1340841600000, 569],
  [1340928000000, 584],
  [1341187200000, 592],
  [1341273600000, 599],
  [1341446400000, 609],
  [1341532800000, 605],
  [1341792000000, 613],
  [1341878400000, 608],
  [1341964800000, 604],
  [1342051200000, 598],
  [1342137600000, 604],
  [1342396800000, 606],
  [1342483200000, 606],
  [1342569600000, 606],
  [1342656000000, 614],
  [1342742400000, 604],
  [1343001600000, 603],
  [1343088000000, 600],
  [1343174400000, 574],
  [1343260800000, 574],
  [1343347200000, 585],
  [1343606400000, 595],
  [1343692800000, 610],
  [1343779200000, 606],
  [1343865600000, 607],
  [1343952000000, 615],
  [1344211200000, 622],
  [1344297600000, 620],
  [1344384000000, 619],
  [1344470400000, 620],
  [1344556800000, 621],
  [1344816000000, 630],
  [1344902400000, 631],
  [1344988800000, 630],
  [1345075200000, 636],
  [1345161600000, 648],
  [1345420800000, 665],
  [1345507200000, 656],
  [1345593600000, 668],
  [1345680000000, 662],
  [1345766400000, 663],
  [1346025600000, 675],
  [1346112000000, 674],
  [1346198400000, 673],
  [1346284800000, 663],
  [1346371200000, 665],
  [1346716800000, 674],
  [1346803200000, 670],
  [1346889600000, 676],
  [1346976000000, 680],
  [1347235200000, 662],
  [1347321600000, 660],
  [1347408000000, 669],
  [1347494400000, 682],
  [1347580800000, 691],
  [1347840000000, 699],
  [1347926400000, 701],
  [1348012800000, 702],
  [1348099200000, 698],
  [1348185600000, 700],
  [1348444800000, 690],
  [1348531200000, 673],
  [1348617600000, 665],
  [1348704000000, 681],
  [1348790400000, 667],
  [1349049600000, 659],
  [1349136000000, 661],
  [1349222400000, 671],
  [1349308800000, 666],
  [1349395200000, 652],
  [1349654400000, 638],
  [1349740800000, 635],
  [1349827200000, 640],
  [1349913600000, 628],
  [1350000000000, 629],
  [1350259200000, 634],
  [1350345600000, 649],
  [1350432000000, 644],
  [1350518400000, 632],
  [1350604800000, 609],
  [1350864000000, 634],
  [1350950400000, 613],
  [1351036800000, 616],
  [1351123200000, 609],
  [1351209600000, 604],
  [1351641600000, 595],
  [1351728000000, 596],
  [1351814400000, 576],
  [1352073600000, 584],
  [1352160000000, 582],
  [1352246400000, 558],
  [1352332800000, 537],
  [1352419200000, 547],
  [1352678400000, 542],
  [1352764800000, 542],
  [1352851200000, 536],
  [1352937600000, 525],
  [1353024000000, 527],
  [1353283200000, 565],
  [1353369600000, 560],
  [1353456000000, 561],
  [1353628800000, 571],
  [1353888000000, 589],
  [1353974400000, 584],
  [1354060800000, 582],
  [1354147200000, 589],
  [1354233600000, 585],
  [1354492800000, 586],
  [1354579200000, 575],
  [1354665600000, 538],
  [1354752000000, 547],
  [1354838400000, 533],
  [1355097600000, 529],
  [1355184000000, 541],
  [1355270400000, 539],
  [1355356800000, 529],
  [1355443200000, 509],
  [1355702400000, 518],
  [1355788800000, 533],
  [1355875200000, 526],
  [1355961600000, 521],
  [1356048000000, 519],
  [1356307200000, 520],
  [1356480000000, 513],
  [1356566400000, 515],
  [1356652800000, 509],
  [1356912000000, 532],
  [1357084800000, 549],
  [1357171200000, 542],
  [1357257600000, 527],
  [1357516800000, 523],
  [1357603200000, 525],
  [1357689600000, 517],
  [1357776000000, 523],
  [1357862400000, 520],
  [1358121600000, 501],
  [1358208000000, 485],
  [1358294400000, 506],
  [1358380800000, 502],
  [1358467200000, 500],
  [1358812800000, 504],
  [1358899200000, 514],
  [1358985600000, 450],
  [1359072000000, 439],
  [1359331200000, 449],
  [1359417600000, 458],
  [1359504000000, 456],
  [1359590400000, 455],
  [1359676800000, 453],
  [1359936000000, 442],
  [1360022400000, 457],
  [1360108800000, 457],
  [1360195200000, 468],
  [1360281600000, 474],
  [1360540800000, 479],
  [1360627200000, 467],
  [1360713600000, 467],
  [1360800000000, 466],
  [1360886400000, 460],
  [1361232000000, 459],
  [1361318400000, 448],
  [1361404800000, 446],
  [1361491200000, 450],
  [1361750400000, 442],
  [1361836800000, 448],
  [1361923200000, 444],
  [1362009600000, 441],
  [1362096000000, 430],
  [1362355200000, 420],
  [1362441600000, 431],
  [1362528000000, 425],
  [1362614400000, 430],
  [1362700800000, 431],
  [1362960000000, 437],
  [1363046400000, 428],
  [1363132800000, 428],
  [1363219200000, 432],
  [1363305600000, 443],
  [1363564800000, 455],
  [1363651200000, 454],
  [1363737600000, 452],
  [1363824000000, 452],
  [1363910400000, 461],
  [1364169600000, 463],
  [1364256000000, 461],
  [1364342400000, 452],
  [1364428800000, 442],
  [1364774400000, 428],
  [1364860800000, 429],
  [1364947200000, 431],
  [1365033600000, 427],
  [1365120000000, 423],
  [1365379200000, 426],
  [1365465600000, 426],
  [1365552000000, 435],
  [1365638400000, 434],
  [1365724800000, 429],
  [1365984000000, 419],
  [1366070400000, 426],
  [1366156800000, 402],
  [1366243200000, 392],
  [1366329600000, 390],
  [1366588800000, 398],
  [1366675200000, 406],
  [1366761600000, 405],
  [1366848000000, 408],
  [1366934400000, 417],
  [1367193600000, 430],
  [1367280000000, 442],
  [1367366400000, 439],
  [1367452800000, 445],
  [1367539200000, 449],
  [1367798400000, 460],
  [1367884800000, 458],
  [1367971200000, 463],
  [1368057600000, 456],
  [1368144000000, 452],
];

export default data;
